import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export type TComplainRes = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  meetingRoomComplains: TComplain[];
};

export type TComplain = {
  id: string;
  createdAt?: string;
  meetingRoomName?: string;
  complainCategory?: string;
  complainDetail?: string;
  isResolved?: boolean;
  resolvedAt?: string;
};

//FEAT: (new) 미처리된 민원 조회하기
export const getIncompletedComplain = async (page: number): Promise<ResponseType<TComplainRes>> => {
  try {
    const res = await instance.get(`/meeting-room-complain/incompleted/${page}`);
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: error ?? "" };
  }
};

//FEAT: (new) 처리된 민원 조회하기
export const getCompletedComplain = async (page: number): Promise<ResponseType<TComplainRes>> => {
  try {
    const res = await instance.get(`/meeting-room-complain/completed/${page}`);
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: error ?? "" };
  }
};

//FEAT: (new) 민원 처리 완료하기
export const resovleComplain = async (meetingRoomComplainIdList: string[]): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/meeting-room-complain/resolve", {
      meetingRoomComplainIdList: meetingRoomComplainIdList,
    });
    return { success: res.data.result };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//FEAT: (new) 민원 처리 취소하기
export const revokeComplain = async (meetingRoomComplainIdList: string[]): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/meeting-room-complain/revoke", {
      meetingRoomComplainIdList: meetingRoomComplainIdList,
    });
    return { success: res.data.result };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//FEAT: (new) 본인이 민원 담당자인지 확인하기
export const checkIsHost = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.get("/meeting-room-complain/check-host");
    return { success: res.data.result };
  } catch (error: any) {
    return { success: false };
  }
};
